import React from 'react'
import { Grid, List, ListItem, ListItemText, Collapse, withStyles, Button } from '@material-ui/core'
import { arrayMove, List as MovableList } from 'react-movable'
import { maxLength, required, TextInput } from 'react-admin'
// import { states } from '../../../states'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { change, formValueSelector } from 'redux-form'
import AddIcon from '@material-ui/icons/Add'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import PlayerItem from './PlayerItem'
import { RichTextInput } from '../../../../../../../components/inputs'

// const publishedOrProgrammed = (status) => (value) => {
//   return !value && (status === states.programmed || status === states.published) ? 'Requiered' : undefined
// }

const FORM = 'record-form'
const selector = formValueSelector(FORM)

const styles = (theme) => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing.unit,
    '& button': {
      textTransform: 'capitalize',
      paddingLeft: theme.spacing.unit,
      '& svg': {
        fontSize: 20,
        marginRight: theme.spacing.unit / 2,
      },
    },
  },
})

class Players extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  handleChangeOrder = ({ oldIndex, newIndex }) => {
    let newContent = [...this.props.field(this.props.source)]
    newContent = arrayMove(newContent, oldIndex, newIndex)
    newContent = newContent.map((item, index) => ({
      ...item,
      position: index,
    }))
    this.props.change(FORM, this.props.source, newContent)
  }

  handleClickAdd = () => {
    let newContent = this.props.field(this.props.source) ? [...this.props.field(this.props.source)] : []
    if (!newContent) {
      newContent = []
    }
    newContent.push({
      position: newContent.length,
      active: false,
      discr: 'player',
    })
    this.props.change(FORM, this.props.source, newContent)
  }

  handleRemove = (index) => {
    let newContent = [...this.props.field(this.props.source)]
    newContent.splice(index, 1)
    this.props.change(FORM, this.props.source, newContent)
  }

  render() {
    const { field, source, classes } = this.props
    return (
      <>
        <ListItem button onClick={this.handleClick}>
          <ListItemText primary="Players Module" />
          {this.state.open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state.open} timeout="auto" unmountOnExit>
          <List>
            <ListItem>
              <Grid container>
                <Grid item xs={12}>
                  <TextInput fullWidth source="playerModule.label" label="Player Module Label" validate={[required(), maxLength(255)]} />
                </Grid>
                <Grid item xs={12}>
                  <TextInput fullWidth source="playerModule.title" label="Players Module Title" validate={[required(), maxLength(255)]} />
                </Grid>
                <Grid item xs={12}>
                  <RichTextInput fullWidth source="playerModule.content" label="Players Module Description" />
                </Grid>
                {field(source) && (
                  <Grid item xs={12}>
                    <MovableList
                      lockVertically
                      values={field(source)}
                      onChange={this.handleChangeOrder}
                      renderList={({ children, props }) => <div {...props}>{children}</div>}
                      renderItem={({ index, props, isDragged, value }) => (
                        <div {...props} key={value.id || index} style={{ ...props.style, zIndex: 2 }}>
                          <PlayerItem source={`${source}[${index}]`} isDragged={isDragged} handleRemove={this.handleRemove} index={index} />
                        </div>
                      )}
                    />
                  </Grid>
                )}
              </Grid>
            </ListItem>
          </List>
          <div className={classes.toolbar}>
            <Button color="primary" variant="contained" size="small" onClick={this.handleClickAdd}>
              <AddIcon />
              Add
            </Button>
          </div>
        </Collapse>
      </>
    )
  }
}

const enhance = compose(
  connect(
    (state) => ({
      field: (source) => selector(state, source),
    }),
    (dispatch) => ({
      change: (form, field, value) => dispatch(change(form, field, value)),
    })
  ),
  withStyles(styles)
)

export default enhance(Players)
